// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4832":"71c6dfb8","5532":"7209f48d"}[chunkId] + ".chunk.css";
};